import React from "react";
import { Container } from "reactstrap";

import {
  LitterIntro,
  LitterPage,
  VideoSection,
  ParentPedigree
} from "components/Litters/LitterComponents.js";
import SEO from "components/SEO/SEO.js";

const announcement = require("../../assets/img/dogs/litters/sf2027/announcement.jpg");
const pedigreeImage = require("../../assets/img/dogs/litters/sf2027/pedigree.jpg");
const fahrenProfile = require("../../assets/img/dogs/profile-fahren.jpg");
const squeezeProfile = require("../../assets/img/dogs/profile-squeeze.jpg");

const parentHealthSummaries = [
  {
    name: "Squeeze",
    breed: "Border Collie",
    ofaUrl: "https://ofa.org/advanced-search/?appnum=2472724",
    results: [
      { label: "CHIC", value: "pending" },
      { label: "Hips", value: "OFA Good" },
      { label: "Elbows", value: "Normal" },
      { label: "Shoulders", value: "Normal" },
      { label: "Spine", value: "Normal" },
      { label: "CAER", value: "Normal" },
      { label: "DNA", value: "Clear" }
    ]
  },
  {
    name: "Fahren",
    breed: "Papillon",
    ofaUrl: "https://ofa.org/advanced-search/?appnum=2716150",
    results: [
      { label: "CHIC", value: "221216" },
      { label: "Hips", value: "OFA Good" },
      { label: "Patella", value: "Normal" },
      { label: "Adv Cardiac", value: "Normal" },
      { label: "CAER", value: "Normal" },
      { label: "DNA", value: "CDDY & PRA Carrier" }
    ]
  }
];

function SF2027Page() {
  return (
    <>
      <SEO
        title="Squeeze x Fahren 2026/27 | Border Collie Papillon Puppies"
        description="Learn about the planned Squeeze x Fahren 2026/27 sport mix litter from Endgame Sport Dogs."
        path="/litters/squeeze-fahren-2027"
      />
      <LitterPage
        headerBg="sf2027"
        pageClassName="litter-detail-page litter-detail-page-modern"
        footerVariant="dark"
      >
        <section className="litter-detail-section litter-overview-section">
          <Container>
            <LitterIntro
              title="Squeeze × Fahren"
              eyebrow="Planned Sport Mix Litter - Winter 2026/27"
              announcement={announcement}
              announcementAlt="Planned Squeeze and Fahren sport mix litter announcement"
              finalCopy={
                <p>
                  For more information about <a className="litter-inline-link" href="/dogs/squeeze">Squeeze</a>, view her individual page. For more information about Fahren, contact Ginsey St Croix.
                </p>
              }
              healthParents={parentHealthSummaries}
              overviewCopy={
                <>
                  <p>Fahren is a happy and funny dog with a strong work ethic and natural talent for agility. He is very connected to his handler but has the confidence to drive forward, work independently, and commit to obstacles. He genuinely loves agility and puts everything he has into his work. He is playful with other dogs and neutral with people.</p>
                  <p>Squeeze is a highly athletic, driven, and resilient dog who also lives to work. She combines a gentle, cuddly nature with playful energy and has a great off-switch despite her high drive. She remains thoughtful even when highly aroused. She is happy to work for toys, food, or praise, and willing to repeat exercises as many times as asked.</p>
                  <p>I'm expecting this pairing to produce athletic, medium to high drive puppies with good biddability for sports. These are not always "mini border collies" however! Owners should be positive, patient, and able to work with more sensitive breeds. Both parents can sometimes be reserved with unfamiliar people, so I expect some puppies may be more socially selective and less interested in attention from strangers. Preference will be given to homes whose primary sport is agility.</p>
                </>
              }
              variant="modern"
            />
            <ParentPedigree
              className=""
              parents={[
                { name: "Fahren", breed: "Papillon", image: fahrenProfile },
                { name: "Squeeze", breed: "Border Collie", image: squeezeProfile, href: "/dogs/squeeze" }
              ]}
              pedigree={{
                image: pedigreeImage,
                href: "https://dogs.pedigreeonline.com/ele-enzi-el-afrafi-REwwAIXe/pedigree?hypomating=endgames-fresh-squeeze-Wo5Xlt07"
              }}
              variant="modern"
            />
          </Container>
        </section>

        <section className="litter-detail-section litter-media-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Parent Videos"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.youtube.com/embed/videoseries?si=BvZVdePFGhZJZkbt&list=PLPQveJv1WtGs", caption: "Squeeze - UKI Novice" },
                { src: "https://www.youtube.com/embed/yxM8H9i6r9M?si=Z-ScZAL56mRHzZx3", caption: "Squeeze - ISC Agility" },
                { src: "https://www.youtube.com/embed/tiQdv6eFIMc?si=y04Hc_fiiPiE7dRz", caption: "Fahren - Agility" },
              ]}
            />
          </Container>
        </section>
        <section className="litter-detail-section litter-media-section litter-group-video-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Related Dogs"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F868808256309318%2F&show_text=false&width=560&t=0", caption: "Cinco (half sibling to Squeeze, Venus x Hop Sing)" },
                { src: "https://www.youtube.com/embed/6N2UZwqf1E0", caption: "Cool (Full sibling to Squeeze)" },
                { src: "https://www.youtube.com/embed/2_3c-BcuS6U", caption: "Rigatoni (Fahren offspring)" }
              ]}
            />
          </Container>
        </section>
      </LitterPage>
    </>
  );
}

export default SF2027Page;
